import React, { useState } from 'react';
import { addAgent, editAgent } from '../api/mongoServices'; // Import editAgent

const AgentFormModal = ({ agent, editMode, onClose }) => {
  const [form, setForm] = useState({
    name: agent?.name || '',
    number: agent?.number || '',
    balance: agent?.balance || 0,
    role: agent?.role || 'manager',
    password: '' // Initialize password field
  });

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    if (isNaN(Number(form.balance))) {
      alert('Balance must be a number');
      return;
    }
    if (editMode) {
      await editAgent(form.number, { ...form, balance: Number(form.balance) }); // <-- Always send as number
    } else {
      await addAgent({ ...form, balance: Number(form.balance) }); // <-- Always send as number
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <form className="bg-white rounded-lg shadow-lg p-8 w-96" onSubmit={handleSubmit}>
        <h2 className="text-xl font-bold mb-4">{editMode ? 'Edit Agent' : 'Add Agent'}</h2>
        <input name="name" type="text" placeholder="Name" className="border px-3 py-2 w-full mb-3" value={form.name} onChange={handleChange} required />
        <input name="number" type="text" placeholder="WhatsApp Number" className="border px-3 py-2 w-full mb-3" value={form.number} onChange={handleChange} required />
        <input
          name="balance"
          type="number"
          placeholder="Balance"
          className="border px-3 py-2 w-full mb-3"
          value={form.balance}
          onChange={e => setForm({ ...form, balance: e.target.value.replace(/\D/g, '') })} // <-- Only allow digits
          required
        />
        <select name="role" className="border px-3 py-2 w-full mb-3" value={form.role} onChange={handleChange}>
          <option value="manager">Manager</option>
          <option value="assistant">Assistant</option>
        </select>
        <input
          name="password"
          type="text"
          placeholder="Password"
          className="border px-3 py-2 w-full mb-3"
          value={form.password}
          onChange={handleChange}
          required={!editMode}
        />
        <button className="bg-blue-600 text-white px-4 py-2 rounded w-full font-bold" type="submit">
          {editMode ? 'Update' : 'Add'}
        </button>
        <button className="mt-3 text-gray-500 underline w-full" type="button" onClick={onClose}>Cancel</button>
      </form>
    </div>
  );
};

export default AgentFormModal;